import { MAX_SELECTED_RECORDS, formatRecordCount } from "../selection/tableSelection";
import { formatNumber } from "../utils/utility";
import { SelectionBannerProps } from "./SelectionBanner.types";

const Banner = "alert alert-info alert-compact mb-0 d-flex align-items-center form-table-selection-summary";

/**
 * Says what is selected, and lets the user go from the records on this page to every
 * record, or clear the selection. Told the counts rather than the records, as the lists
 * and the search each hold their selection differently.
 */
export function SelectionBanner({
  selectedCount,
  totalRecords,
  allOnPageSelected = false,
  allPagesSelected = false,
  hasMorePages = false,
  alwaysShow = false,
  clearSelection,
  selectAllPages,
}: SelectionBannerProps) {
  const divider = <span className="vr mx-2" aria-hidden="true" />;
  const clearButton = (
    <>
      {divider}
      <button type="button" className="btn btn-link p-0" onClick={clearSelection}>
        Clear selection
      </button>
    </>
  );

  if (allPagesSelected) {
    return (
      <div className={Banner}>
        <span>
          All <strong>{formatNumber(totalRecords)}</strong>{" "}
          {totalRecords === 1 ? "record is" : "records are"} selected.
        </span>
        {clearButton}
      </div>
    );
  }

  if (!selectedCount && !alwaysShow) {
    return null;
  }

  const canSelectAll = alwaysShow ? selectedCount < totalRecords : allOnPageSelected && hasMorePages;

  return (
    <div className={Banner}>
      <span>
        <strong>
          {alwaysShow
            ? `${formatNumber(selectedCount)} of ${formatRecordCount(totalRecords)}`
            : formatRecordCount(selectedCount)}
        </strong>{" "}
        selected.
      </span>
      {canSelectAll && (
        <>
          {divider}
          <button type="button" className="btn btn-link p-0" onClick={selectAllPages}>
            Select all {formatNumber(totalRecords)} records
          </button>
        </>
      )}
      {selectedCount > 0 && clearButton}
      {selectedCount >= MAX_SELECTED_RECORDS && (
        <span className="text-muted ms-2">
          (maximum of {formatNumber(MAX_SELECTED_RECORDS)} - use Select all for more)
        </span>
      )}
    </div>
  );
}

export default SelectionBanner;
